import { useEffect, useRef } from "react";
import { FileUtils } from "@/utils/FileUtils";
import { Toast } from "@/ui-kit";
import { useTranslation } from "react-i18next";
import { useFormContext } from "react-hook-form";

export const useGetFileFromUrl = (
  name: string,
  callback: (files: File[]) => void,
) => {
  const { t } = useTranslation();
  const { getValues } = useFormContext();
  const fileRef = useRef<File[] | undefined>(undefined);

  useEffect(() => {
    const values: string | string[] | undefined = getValues(name + "Url");
    const urls = typeof values === "string" ? [values] : (values ?? []);

    if (!urls.length) {
      fileRef.current = undefined;
      return;
    }

    const loadFiles = async () => {
      try {
        const promises = urls.map(async (url) => {
          return FileUtils.convertUrlToFile({ url });
        });

        const files = await Promise.all(promises);

        // Tag each file with its original URL for tracking
        const taggedFiles = files.map((file, index) => {
          Object.defineProperty(file, '__originalUrl', {
            value: urls[index],
            enumerable: false,
            writable: false,
            configurable: false,
          });
          return file;
        });

        fileRef.current = taggedFiles;
        callback(taggedFiles);
      } catch (error) {
        Toast.error({ title: t(`error.profile_picture_load_failed`) });
        console.error(error);
        fileRef.current = undefined;
      }
    };

    void loadFiles();
  }, [t, name, getValues, callback]);

  return {
    fileRef,
  };
};
